export const extractFileNameFromPath = (path: string) => {
  try {
    const url = new URL(path);
    return decodeURIComponent(url.pathname.split("/").pop() ?? "");
  } catch {
    console.error(`${path} is not a valid url.`);
  }
};
